import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { columnSpecificV0Schema } from './v0';
import { columnLegacyV0Schema } from '../legacy/entity';
import { migrateLegacySpecificToV0 } from '../legacy/migration';

export const SpecificColumnEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: columnSpecificV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: columnLegacyV0Schema, up: migrateLegacySpecificToV0 }],
});

export type SpecificColumn = InferredEntity<typeof SpecificColumnEntitySchema>;
